export default "__VITE_ASSET__93d01a72__"